import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  Box,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

// Dedicated delete confirmation dialog for the Compliance Master page.
// A separate component (not the shared ConfirmationDialog, which is used across
// many pages) so its Confirm/Cancel button pattern can differ while keeping the
// existing Compliance wording.
const ComplianceDeleteDialog = ({ open, onClose, onConfirm, onCancel, count = 0 }) => {
  const handleCancel = onCancel || onClose

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return
        if (onClose) onClose()
      }}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '0px', 
        },
      }}
    >
      <DialogContent
        sx={{
          padding: '24px 24px 0px 24px',
          textAlign: 'left',
        }}
      >
        {/* Title + close */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            pb: '16px',
          }}
        >
          <Typography
            component="span"
            sx={{  
              fontSize: '24px',
              lineHeight: '130%',
              color: '#111113',
              margin: 0,
            }}
          >
           Are you sure you want to delete the compliance entries?
          </Typography>
          {onClose && (
            <IconButton onClick={onClose} sx={{ p: 0.5 }}>
              <CloseIcon sx={{ fontSize: 22, color: '#000000' }} />
            </IconButton>
          )}
        </Box>

        {/* Message (same wording as the existing compliance delete confirmation) */}
        <Typography
          sx={{
            color: 'var(--forbrand-secondary)',
            fontSize: '14px',
          }}
        >
          {`This action cannot be undone (${count} selected)`}
        </Typography>
      </DialogContent>

      {/* Actions: Cancel + Confirm */}
      <DialogActions
        sx={{
          padding: '32px 24px 24px 0px',
          justifyContent: 'flex-end',
          gap: '12px',
        }}
      >
        <Button
          onClick={handleCancel}
          sx={{
            color: 'var(--forbrand-primary)',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: 'var(--forbrand-bg-variant)',
            color: 'var(--forbrand-brand-varient)',
            borderRadius: '6px',
            padding: '8px 16px',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            boxShadow: 'none',
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ComplianceDeleteDialog
